<template>
  <div class="card h-100 product-card text-lg-start">
    <div class="product-compare-actions">
      <button v-if="Object.values(comparison).includes(product.product_id)" 
              class="bg-transparent border-0 p-0 product-compare-remove" 
              @click="$emit('removeFromComparison', product.product_id)">
        <slot name="close-circle-icon" :product="product"></slot>
      </button>
      <button v-if="!Object.values(comparison).includes(product.product_id) && Object.values(comparison).includes(null)" 
              class="bg-transparent border-0 p-0 product-compare-add" 
              @click="$emit('addToComparison', product.product_id)">
        <slot name="plus-circle-icon" :product="product"></slot>
      </button>
    </div>
    <a :href="product.url" :aria-label="product.title">
      <div class="image-wrap">
        <img :src="product.image.url" :alt="product.image.alt" class="card-img-top"/>
      </div>
    </a>
    <div class="card-body d-flex flex-column">
      <h3 class="card-title product-title h4" :id="'product-result-' + product.product_id">
        <a :href="product.url" class="text-black" v-html="product.title"></a>
      </h3>
      <h4 v-if="product.subtitle" class="card-title product-title h5">
        {{ product.subtitle }}
      </h4>
      <strong class="card-supertitle">
        <span v-for="term in product.series" :class="'text-' + term.color">
          {{ term.title }}
        </span>
      </strong>
      <div class="rte d-none d-lg-block fw-medium mb-2">
        {{ product.description }}
      </div>
      <div v-if="0 < product.price" class="product-card-price fw-bold mb-2">
        <slot name="product-result-price-prefix">From</slot>
        {{ product.msrp_from }}
      </div>
      <div
           v-if="product.isRatingEnabled"
           ref="rating"
           class="product-card-rating"
           data-bv-show="inline_rating"
           :data-bv-product-id="product.product_id"
      ></div>
    </div>
    <div class="card-footer bg-transparent d-none d-lg-block">
      <slot name="product-result-button" :product="product"></slot>
    </div>
  </div>
  
</template>

<script>
export default {
  props: ['product', 'comparison'],
  computed: {
    sortPrice() {
      return parseFloat(this.product.msrp_from.replace(/[^\d\.]/, ''));
    }
  },
  methods: {
    watchRatings(mutationsList, observer) {
      let ratingValueElem = this.$refs.rating.querySelector('.bv_averageRating_component_container .bv_text');
      if (ratingValueElem) {
        this.product.rating ??= parseFloat(ratingValueElem.innerHTML);
        this.ratingsObserver.disconnect();
      }
    }
  },
  emits: ['removeFromComparison', 'addToComparison'],
  mounted() {
    if (!this.product.rating) {
      this.ratingsObserver = new MutationObserver(this.watchRatings);
      this.ratingsObserver.observe(this.$refs.rating, { childList: true, subtree: true })
    }
    this.product.price ??= this.sortPrice;
  }
}
</script>
